<template>
  <div class="modal modal-qr fade" id="qrcode-modal-member" tabindex="-1" role="dialog" aria-labelledby="qrcode-modal-member"
    style="z-index: 10000;">
    <div class="modal-dialog modal-dialog-centered qr-dialog" role="document">
      <div class="modal-content qr-card" :style="cardStyle">
        <button type="button" class="qr-close" data-bs-dismiss="modal" aria-label="Close">
          <span class="material-icons-round">close</span>
        </button>
        <div class="modal-body qr-body">
          <p class="qr-title">My QR Code</p>
          <div class="qr-frame">
            <VueQRCodeComponent :text="phoneNumber" size="176" color="#1a1c1a" bg-color="#ffffff" error-level="L" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueQRCodeComponent from 'vue-qrcode-component'
export default {
  name: "QrcodeReward",
  components: {
    VueQRCodeComponent
  },
  props: {
    phoneNumber: {
      type: String,
      default: 'Phone number not found!',
    },
  },
  computed: {
    cardStyle() {
      return {
        "--qr-color": this.$store.state.mainThemeColorTheme2 || this.$store.state.color,
      };
    },
  },
};
</script>
<style scoped>
.bg-color-common {
  color: #fff;
}

.qr-dialog {
  max-width: 300px;
  margin: 1.75rem auto;
}

.qr-card {
  position: relative;
  border: none;
  border-radius: 24px;
  padding: 28px 24px 26px;
  box-shadow: 0 20px 45px rgba(25, 28, 30, 0.18);
  font-family: "Plus Jakarta Sans", "Manrope", system-ui, sans-serif;
}

.qr-close {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 9999px;
  background: color-mix(in srgb, var(--qr-color, #f9dd4b) 12%, #ffffff);
  color: #1a1c1a;
  cursor: pointer;
  padding: 0;
}

.qr-close .material-icons-round {
  font-size: 18px;
}

.qr-body {
  padding: 0;
  text-align: center;
}

.qr-title {
  margin: 0 0 18px;
  font-weight: 800;
  font-size: 1.05rem;
  color: #1a1c1a;
}

.qr-frame {
  display: inline-flex;
  padding: 16px;
  border-radius: 20px;
  border: 2px solid var(--qr-color, #f9dd4b);
  background: #ffffff;
  box-shadow: 0 6px 18px rgba(25, 28, 30, 0.06);
}

#qrcode-modal .modal-dialog {
  height: 70vh;
}

#qrcode-modal .modal-body {
  overflow-y: scroll;
  height: 68vh;
}

.wrap-qrcode {
  width: 200px;
  margin: 0px auto;
}

#qrcode-modal p {
  margin: 0px;
}

/* Css model */
.modal.modal-left .modal-dialog,
.modal.modal-right .modal-dialog,
.modal.modal-top .modal-dialog,
.modal.modal-bottom .modal-dialog {
  -webkit-transform: translate3d(0%, 0, 0);
  -ms-transform: translate3d(0%, 0, 0);
  -o-transform: translate3d(0%, 0, 0);
  transform: translate3d(0%, 0, 0);
}

/* Left & Right */

.modal.modal-left .modal-dialog,
.modal.modal-right .modal-dialog {
  position: fixed;
  margin: auto;
  width: 500px;
  max-width: 100%;
  height: 100%;
}

.modal.modal-left .modal-content,
.modal.modal-right .modal-content {
  height: 100%;
  overflow-y: auto;
}

.modal.modal-left .modal-body,
.modal.modal-right .modal-body {
  padding: 15px 15px 80px;
}

.modal.modal-left.fade .modal-dialog {
  left: -500px;
  -webkit-transition: opacity 0.3s linear, left 0.3s ease-out;
  -moz-transition: opacity 0.3s linear, left 0.3s ease-out;
  -o-transition: opacity 0.3s linear, left 0.3s ease-out;
  transition: opacity 0.3s linear, left 0.3s ease-out;
}

.modal.modal-left.fade.show .modal-dialog {
  left: 0;
}

.modal.modal-right.fade .modal-dialog {
  right: -500px;
  -webkit-transition: opacity 0.3s linear, right 0.3s ease-out;
  -moz-transition: opacity 0.3s linear, right 0.3s ease-out;
  -o-transition: opacity 0.3s linear, right 0.3s ease-out;
  transition: opacity 0.3s linear, right 0.3s ease-out;
}

.modal.modal-right.fade.show .modal-dialog {
  right: 0;
}

.modal.modal-left .modal-content,
.modal.modal-right .modal-content,
.modal.modal-top .modal-content,
.modal.modal-bottom .modal-content,
.modal.modal-full .modal-content {
  border-radius: 0;
  border: none;
}

.modal.modal-left .modal-dialog.modal-sm,
.modal.modal-right .modal-dialog.modal-sm {
  width: 300px;
}

.modal.modal-left .modal-dialog.modal-lg,
.modal.modal-right .modal-dialog.modal-lg {
  width: 800px;
}

.modal.modal-left .modal-dialog.modal-xl,
.modal.modal-right .modal-dialog.modal-xl {
  width: 1140px;
}

/* Top and Bottom */

.modal.modal-top .modal-dialog,
.modal.modal-bottom .modal-dialog {
  position: fixed;
  margin: auto;
  width: 100%;
  max-width: 100%;
  height: auto;
}

.modal.modal-top .modal-content,
.modal.modal-bottom .modal-content {
  height: auto;
  overflow-y: auto;
}

.modal.modal-top .modal-body,
.modal.modal-bottom .modal-body {
  padding: 15px 15px;
}

/* Top */

.modal.modal-top.fade .modal-dialog {
  top: -100%;
  -webkit-transition: opacity 0.3s linear, top 0.3s ease-out;
  -moz-transition: opacity 0.3s linear, top 0.3s ease-out;
  -o-transition: opacity 0.3s linear, top 0.3s ease-out;
  transition: opacity 0.3s linear, top 0.3s ease-out;
}

.modal.modal-top.fade.show .modal-dialog {
  top: 0;
}

/* Bottom */

.modal.modal-bottom.fade .modal-dialog {
  bottom: -100%;
  -webkit-transition: opacity 0.3s linear, bottom 0.3s ease-out;
  -moz-transition: opacity 0.3s linear, bottom 0.3s ease-out;
  -o-transition: opacity 0.3s linear, bottom 0.3s ease-out;
  transition: opacity 0.3s linear, bottom 0.3s ease-out;
}

.modal.modal-bottom.fade.show .modal-dialog {
  bottom: 0;
}

.modal.modal-bottom.fade .modal-dialog {
  bottom: -100%;
}

/* Full Screen */

.modal.modal-full .modal-dialog {
  position: fixed;
  margin: auto;
  width: 100%;
  max-width: 100%;
  height: 100%;
}

.modal.modal-full .modal-content {
  height: 100%;
  overflow-y: auto;
}

.modal.modal-full .close-modal {
  position: fixed;
  top: 0;
  right: 3rem;
}

/* Footer */

.modal-footer-fixed {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #fff;
  border-radius: 0;
}

/* XS */

.modal.modal-left.xs .modal-body,
.modal.modal-right.xs .modal-body {
  padding: 15px;
}

.btn-close {
  font-size: 25px;
  color: #222 !important;
}

.btn-close span {
  color: #222;
}

.wrap-code {
  border: 1px solid rgb(228, 228, 228);
  position: relative;
  width: 200px;
  margin: 0px auto;
  left: 12px;
}

.wrap-code i {
  position: absolute;
  right: 5px;
  top: 5px;
}

</style>
